export const baseURL = 'https://jamunona-api.onrender.com/api';

// ----RECENTLY USE-------//
// export const newBaseUrl = 'https://jumunona.onrender.com/admin'; 


export const baseUrl = 'https://jumunona.onrender.com/admin'; 

